"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaAssistantEtapes = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _semanticUiReact = require("semantic-ui-react");

require("../css/mfa-assistant-etapes.css");

require("../css/mfa-bouton.css");

var _utilitaires = require("../utils/utilitaires");

var _MfaBouton = require("./MfaBouton");

var _MfaLien = require("./MfaLien");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MfaAssistantEtapesSansRouteur = /*#__PURE__*/function (_Component) {
  _inherits(MfaAssistantEtapesSansRouteur, _Component);

  var _super = _createSuper(MfaAssistantEtapesSansRouteur);

  function MfaAssistantEtapesSansRouteur(props) {
    var _this;

    _classCallCheck(this, MfaAssistantEtapesSansRouteur);

    _this = _super.call(this, props);
    _this.state = {
      etapeCourante: (0, _utilitaires.estDefini)(_this.props.etapeInitiale) ? _this.props.etapeInitiale : 0
    };
    return _this;
  }

  _createClass(MfaAssistantEtapesSansRouteur, [{
    key: "allerAEtape",
    value: function allerAEtape(no) {
      this.setState({
        etapeCourante: no
      });
    }
  }, {
    key: "etapeDisponible",
    value: function etapeDisponible(index) {
      var prochaineEtape = this.props.etapes[index];

      if (!prochaineEtape) {
        return false;
      }

      var fonctionDisponibilite = prochaineEtape.fonctionDisponibilite;
      return typeof fonctionDisponibilite === 'function' ? fonctionDisponibilite() : fonctionDisponibilite;
    }
  }, {
    key: "terminaisonDisponible",
    value: function terminaisonDisponible() {
      var fonctionTermineDisponible = this.props.fonctionTermineDisponible;
      return typeof fonctionTermineDisponible === 'function' ? fonctionTermineDisponible() : fonctionTermineDisponible;
    }
  }, {
    key: "obtenirComposanteEtape",
    value: function obtenirComposanteEtape() {
      var index = this.obtenirEtapeCourante();
      var etapeCourante = this.props.etapes[index];
      var Composante = etapeCourante.composante;
      return /*#__PURE__*/_react.default.createElement(Composante, etapeCourante.proprietes);
    }
  }, {
    key: "obtenirEtapeCourante",
    value: function obtenirEtapeCourante() {
      return (0, _utilitaires.estDefini)(this.props.etapeCourante) ? this.props.etapeCourante : this.state.etapeCourante;
    }
  }, {
    key: "annulation",
    value: function annulation() {
      var doitAnnuler = true;

      if (typeof this.props.surAnnulation === 'function') {
        doitAnnuler = this.props.surAnnulation();
      }

      if (doitAnnuler) {
        if ((0, _utilitaires.estDefini)(this.props.cheminAnnulation)) {
          this.props.history.push(this.props.cheminAnnulation);
        } else {
          this.props.history.goBack();
        }
      }
    }
  }, {
    key: "precedent",
    value: function precedent() {
      var doitPasserPrecedent = true;
      var indexEtapeCourante = this.obtenirEtapeCourante();

      if (typeof this.props.surPrecedent === 'function') {
        var etapeCourante = this.props.etapes[indexEtapeCourante];
        doitPasserPrecedent = this.props.surPrecedent(etapeCourante, indexEtapeCourante);
      }

      if (doitPasserPrecedent) {
        this.allerAEtape(indexEtapeCourante - 1);
      }
    }
  }, {
    key: "suivantDisponible",
    value: function suivantDisponible(etapeCourante) {
      var suivantDisponible = this.props.suivantDisponible;

      if (!(0, _utilitaires.estDefini)(suivantDisponible)) {
        return this.etapeDisponible(etapeCourante + 1);
      }

      return suivantDisponible(etapeCourante);
    }
  }, {
    key: "suivant",
    value: function suivant() {
      var doitPasserSuivant = true;
      var indexEtapeCourante = this.obtenirEtapeCourante();

      if (typeof this.props.surSuivant === 'function') {
        var etapeCourante = this.props.etapes[indexEtapeCourante];
        doitPasserSuivant = this.props.surSuivant(etapeCourante, indexEtapeCourante);
      }

      if (doitPasserSuivant) {
        this.allerAEtape(indexEtapeCourante + 1);
      }
    }
  }, {
    key: "terminaison",
    value: function () {
      var _terminaison = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var doitTerminer, surTerminaison, retourTerminaison;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                doitTerminer = true;
                surTerminaison = this.props.surTerminaison;

                if (!(typeof surTerminaison === 'function')) {
                  _context.next = 11;
                  break;
                }

                retourTerminaison = this.props.surTerminaison();

                if (!this.props.terminaisonAsync) {
                  _context.next = 10;
                  break;
                }

                _context.next = 7;
                return retourTerminaison;

              case 7:
                doitTerminer = _context.sent;
                _context.next = 11;
                break;

              case 10:
                doitTerminer = retourTerminaison;

              case 11:
                if (doitTerminer) {
                  if ((0, _utilitaires.estDefini)(this.props.cheminTerminaison)) {
                    this.props.history.push(this.props.cheminTerminaison);
                  } else {
                    this.props.history.goBack();
                  }
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function terminaison() {
        return _terminaison.apply(this, arguments);
      }

      return terminaison;
    }()
  }, {
    key: "surCliqueLien",
    value: function surCliqueLien(noEtape) {
      var surCliqueLien = this.props.surCliqueLien;

      if ((0, _utilitaires.estDefini)(surCliqueLien)) {
        surCliqueLien(noEtape);
      } else {
        this.allerAEtape(noEtape);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var etapeCourante = this.obtenirEtapeCourante();
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-assistant-etapes"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-assistant-etapes-menu"
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Step.Group, {
        vertical: true
      }, this.props.etapes.map(function (etape, index) {
        return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Step, {
          key: 'etape-' + index,
          active: etapeCourante === index,
          disabled: !_this2.etapeDisponible(index)
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Step.Title, null, (0, _utilitaires.estDefini)(etape.titre) ? /*#__PURE__*/_react.default.createElement("div", {
          key: "lien-".concat(index)
        }, /*#__PURE__*/_react.default.createElement(_MfaLien.MfaLien, {
          key: "lien-".concat(index),
          onClick: function onClick() {
            return _this2.surCliqueLien(index);
          }
        }, /*#__PURE__*/_react.default.createElement("span", null, etape.titre), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          style: {
            marginLeft: '5px'
          },
          color: etape.iconeCouleur,
          name: etape.iconeNom
        }))) : "\xC9tape ".concat(index + 1)), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Step.Description, null, etape.description));
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-assistant-etapes-corps"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-assistant-etapes-contenu"
      }, this.obtenirComposanteEtape()), this.props.montrerPied !== false ? /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-assistant-etapes-pied"
      }, etapeCourante === 0 ? /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        estSecondaire: true,
        onClick: function onClick() {
          return _this2.annulation();
        }
      }, this.props.texteAnnuler || 'Annuler') : /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        estSecondaire: true,
        onClick: function onClick() {
          return _this2.precedent();
        }
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        className: "precedent",
        name: "arrow circle left"
      }), this.props.textePrecedent || 'Précédent'), etapeCourante < this.props.etapes.length - 1 ? /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        estPrincipal: true,
        onClick: function onClick() {
          return _this2.suivant();
        },
        desactive: !this.suivantDisponible(etapeCourante)
      }, this.props.texteSuivant || 'Suivant', /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        className: "suivant",
        name: "arrow circle right"
      })) : /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        estPrincipal: true,
        onClick: function onClick() {
          return _this2.terminaison();
        },
        desactive: !this.terminaisonDisponible()
      }, this.props.texteTerminer || 'Terminer')) : null));
    }
  }]);

  return MfaAssistantEtapesSansRouteur;
}(_react.Component);

var MfaAssistantEtapes = (0, _reactRouterDom.withRouter)(MfaAssistantEtapesSansRouteur);
exports.MfaAssistantEtapes = MfaAssistantEtapes;